var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><br><br><div style=\"width: 240px;\"><h3>You can download the application and reports you have access to in PDF and any attachment files by clicking here.</h3></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/tour/intro/step2.jade
// module id = 813
// module chunks = 0